// @flow
import dispatchAsync from 'utils/dispatchAsync';
import type { ZuzuThunk } from 'types';

export type AppointmentType = {
  appointmentId: string,
  title: string,
  description: string,
  dates: Array<number>,
  image: ?string,
  createdAt: number,
};

export type LoadAppointmentsAction = {
  type: 'LOAD_APPOINTMENTS',
  payload?: Array<AppointmentType>,
  meta: {
    done: boolean,
    error?: boolean,
  },
};
export const LOAD_APPOINTMENTS = 'LOAD_APPOINTMENTS';
export const loadAppointments = (): ZuzuThunk => async dispatch => {
  return dispatchAsync({
    type: LOAD_APPOINTMENTS,
    url: '/api/management/appointment/all',
    method: 'get',
    dispatch,
    transform: payload => [
      ...payload.sort((a, b) => b.createdAt - a.createdAt),
    ],
  });
};

export const CREATE_APPOINTMENT = 'CREATE_APPOINTMENT';
export const createAppointment = (
  title: string,
  description: string,
  dates: Array<number>,
  image: ?string
): ZuzuThunk => async dispatch => {
  return dispatchAsync({
    type: CREATE_APPOINTMENT,
    url: '/api/management/appointment',
    method: 'post',
    dispatch,
    body: {
      title,
      description,
      dates,
      image,
    },
  });
};

export const DELETE_APPOINTMENT = 'DELETE_APPOINTMENT';
export const deleteAppointment = (
  appointmentId: string
): ZuzuThunk => async dispatch =>
  dispatchAsync({
    type: DELETE_APPOINTMENT,
    url: '/api/management/appointment/delete',
    method: 'post',
    dispatch,
    body: { appointmentId },
  });

export const EDIT_APPOINTMENT = 'EDIT_APPOINTMENT';
export const editAppointment = (
  appointmentId: string,
  field: string,
  value: string | Array<number>
): ZuzuThunk => async dispatch =>
  dispatchAsync({
    type: EDIT_APPOINTMENT,
    url: '/api/management/appointment',
    method: 'put',
    dispatch,
    body: {
      appointmentId,
      field,
      value,
    },
  });



// WEBPACK FOOTER //
// ./src/redux/actions/appointments.js